<template>
    <div id="browse">
        <Navi currentPage="2-1"></Navi>
        <div class="body_container main_context">
            <div class="breadcrumb_con">
                <el-breadcrumb separator="/" class="breadcrumb">
                    <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                    <el-breadcrumb-item>Analyze</el-breadcrumb-item>
                    <el-breadcrumb-item>Estimate associated tissues/cell-types & genes</el-breadcrumb-item>
                    <el-breadcrumb-item>Results</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div v-if="loading" class="pcga-loading">
                <el-row
                    v-loading="true"
                    element-loading-background="rgba(255, 255, 255, 1)"
                    style="height:100%"
                ></el-row>
                <!-- <pcga-loading></pcga-loading> -->
            </div>
            <div v-if="!loading">
                <div class="results" v-if="!error_page">
                    <div class="tip_box">
                        <i class="el-icon-warning"></i> The webpage tracks the progress and results of your job, please mark the
                        URL for checking it at anytime. The job will run about 30 minutes. The webpage will refresh automatically until the job is completed. 
                        The results page will be kept for 30 days after the job is completed.
                    </div>
                    <el-collapse v-model="activeCollapse1">
                        <el-collapse-item name="1">
                            <template slot="title">
                                <i class="header-icon el-icon-info"></i> Job progress
                            </template>
                            <div class="task_progress">
                                <div class="current_status_box" >
                                   <p style="margin:0">Current status: 
                                       <span v-if="progress_num == 3" style="color:#F56C6C;font-weight:bold"><i class="el-icon-loading"></i> Queued </span> 
                                       <span v-if="progress_num == 4" style="color:#E6A23C;font-weight:bold"><i class="el-icon-loading"></i> Running </span> 
                                       <span v-if="progress_num == 5" style="color:#67C23A;font-weight:bold"><i class="el-icon-finished"></i> Completed </span> 
                                       (Last check:	{{now_time}}).
                                       <span v-if="progress_num != 5 && email!=''">You have submitted email address and you will be notified when the job is completed.</span>
                                       <span v-if="progress_num != 5 && email==''">
                                           <el-button type="text" icon="el-icon-message" @click="add_email">Notify me via email when job is completed? (optionally)</el-button>
                                        </span>
                                    </p>
                                </div>
                                <!-- <div class="current_status_box" v-if="progress_num == 4">
                                   Current status:<span style="color:#E6A23C;font-weight:bold"><i class="el-icon-loading"></i> Running </span> (Last check:	{{now_time}})
                                    {{email_info}}
                                </div>
                                <div class="current_status_box" v-if="progress_num == 5">
                                   Current status: <span style="color:#67C23A;font-weight:bold"><i class="el-icon-finished"></i> Finished </span>(Last check: {{now_time}})
                                </div> -->
                                <el-steps
                                    :space="220"
                                    :active="progress_num - 1"
                                    process-status="success"
                                    finish-status="success"
                                    :align-center="true"
                                   
                                >
                                    <el-step title="Uploaded GWAS" :description="upload_time"></el-step>
                                    <el-step title="Submitted job" :description="submit_time"></el-step>
                                    <el-step title="Queued" :description="submit_time"></el-step>
                                    <el-step title="Running" :description="run_time"></el-step>
                                    <el-step title="Completed" :description="finish_time"></el-step>
                                </el-steps>

                            </div>
                        </el-collapse-item>
                        <el-collapse-item name="2-1" v-if="progress_num == 5">
                            <template slot="title">
                                <i class="header-icon el-icon-info"></i> Final status of job
                            </template>
                            <el-alert
                                v-if="status_code == 3"
                                title="Failed"
                                type="error"
                                :description="'The job is failed. Information: ' + status_msg+' Please check your GWAS file and options. In case of difficulty, please contact us on limiaoxin@mail.sysu.edu.cn (Prof. Li).'"
                                :closable="false"
                                show-icon
                            ></el-alert>
                            <el-alert
                                v-if="status_code == 4"
                                title="Success"
                                type="success"
                                description="The job ran successfully!"
                                :closable="false"
                                show-icon
                            ></el-alert>
                        </el-collapse-item>
                        <el-collapse-item name="2" >
                            <template slot="title">
                                <i class="header-icon el-icon-info"></i> Summary of job
                            </template>
                            <div class="task_results">
                                <el-descriptions class="margin-top" title :column="3" border>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-user"></i>
                                            Job label
                                        </template>
                                        {{ task_label }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-mobile-phone"></i>
                                            Population
                                        </template>
                                        {{ pop }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-mobile-building"></i>
                                            Reference genome version
                                        </template>
                                        {{ ref_genome }}
                                    </el-descriptions-item>

                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Chromosome column
                                        </template>
                                        <el-tag size="middle" :type="gwas_col_type">{{ chr }}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Position column
                                        </template>
                                        <el-tag size="middle" :type="gwas_col_type">{{ bp }}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            P-value column
                                        </template>
                                        <el-tag size="middle" :type="gwas_col_type">{{ p }}</el-tag>
                                    </el-descriptions-item>

                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-location-outline"></i>
                                            Multiple test correction method
                                        </template>
                                        <el-tag size="middle">{{ multi_test }}</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-tickets"></i>
                                            Family-wise error rate
                                        </template>
                                        {{ fwer }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-tickets"></i>
                                            Max gene number
                                        </template>
                                        {{ max_gene }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Extend size (bp)
                                        </template>
                                        {{ extend_size }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Exclude MHC region
                                        </template>
                                        {{ remove_hla }}
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Tissues datasets
                                        </template>
                                        54 human tissues
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <i class="el-icon-office-building"></i>
                                            Cell types datasets
                                        </template>
                                        {{ cell_types_des }}
                                    </el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item name="3" v-if="status_code == 4">
                            <template slot="title">
                                <i class="header-icon el-icon-info"></i> Results
                            </template>
                            <el-tabs
                                type="border-card"
                                @tab-click="switchRNAdb"
                                v-model="active_RNAdb"
                            >
                                <el-tab-pane
                                    v-for="db of rna_db"
                                    :key="db.id"
                                    :label="db.label"
                                    :name="db.id"
                                    lazy
                                ></el-tab-pane>
                                <div class="context_main_body">
                                    <el-collapse v-model="activeCollapse2" accordion>
                                        <el-collapse-item name="1">
                                            <template slot="title">
                                                <i class="header-icon el-icon-info"></i> Associated tissues/cell types
                                            </template>
                                            <div
                                                class="pcga-result-des"
                                            >Here are associated tissues/cell types. The significance cutoff in bar and pie plot is Bonferroni family-wise error rate (FWER) &lt; 0.05.</div>
                                            <div class="pcga-result-table-box pcga-result-box">
                                                <div>
                                                    <CellTab
                                                        :table_data="cell_table_data"
                                                        :loading="cell_table_data.loading"
                                                        :loadData="loadCellFullData"
                                                        :showRate="false"
                                                    ></CellTab>
                                                </div>
                                            </div>
                                            <div class="pcga-result-fig-box pcga-result-box" v-if="!cell_bar_data.empty">
                                                <Bar :fig_data="cell_bar_data" :loading="cell_bar_data.loading" :empty="cell_bar_data.empty"></Bar>
                                            </div>    
                                            <div class="pcga-result-fig-box pcga-result-box"  v-if="!cell_box_data.empty">
                                                <div class="pcga-result-fig1-box">
                                                    <Box
                                                        :fig_data="cell_box_data"
                                                        :loading="cell_box_data.loading"
                                                        :empty="cell_box_data.empty"
                                                    ></Box>
                                                    <Pie
                                                        :fig_data="cell_pie_data"
                                                        :loading="cell_pie_data.loading"
                                                        :empty="cell_pie_data.empty"
                                                    ></Pie>
                                                </div>
                                            </div>
                                        </el-collapse-item>
                                        <el-collapse-item name="2">
                                            <template slot="title">
                                                <i class="header-icon el-icon-info"></i> Associated genes
                                            </template>
                                            <div
                                                class="pcga-result-des"
                                            >Here are significant associated genes after conditional gene based test.</div>
                                            <div class="pcga-result-table-box pcga-result-box">
                                                <div>
                                                    <Tab
                                                        :table_data="gene_table_data"
                                                        :loading="gene_table_data.loading"
                                                        :loadData="loadGeneFullData"
                                                    ></Tab>
                                                </div>
                                            </div>
                                        </el-collapse-item>

                                        <el-collapse-item name="3">
                                            <template slot="title">
                                                <i class="header-icon el-icon-info"></i>Similar phenotypes in PCGA
                                            </template>
                                            <div
                                                class="pcga-result-des"
                                            >Similarity is measured by Jaccard index of associated genes. There are top 50 similar phenotypes.</div>
                                            <div class="pcga-result-table-box pcga-result-box">
                                                <Tab
                                                    :table_data="phenotype_table_data"
                                                    :loading="phenotype_table_data.loading"
                                                    :loadData="loadPhenotypeFullData"
                                                ></Tab>
                                            </div>
                                            <div class="pcga-result-fig-box pcga-result-box"  v-if="!phenotype_box_data.empty">
                                                <div class="pcga-result-fig1-box">
                                                    <Box
                                                        :fig_data="phenotype_box_data"
                                                        :loading="phenotype_box_data.loading"
                                                        :empty="phenotype_box_data.empty"
                                                    ></Box>
                                                    <Pie
                                                        :fig_data="phenotype_pie_data"
                                                        :loading="phenotype_pie_data.loading"
                                                        :empty="phenotype_pie_data.empty"
                                                    ></Pie>
                                                </div>
                                            </div>
                                        </el-collapse-item>
                                    </el-collapse>
                                </div>
                            </el-tabs>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="results" v-else>
                    <el-result icon="error" title="Invalid link" :subTitle="error_msg"></el-result>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Navi from "@/components/navigate.vue";
import Footer from "@/components/footer.vue";
import Box from "@/components/plot/box.vue";
import Pie from "@/components/plot/pie.vue";
import Bar from "@/components/plot/bar.vue";
import Tab from "@/components/plot/common_table.vue";
import CellTab from "@/components/plot/cell_table.vue";
// import SPR from "@/components/show_phenotype_result.vue";
import axios from "axios/dist/axios.min";
import { api_dir, echartTable2vxeTable, getTime } from "@/bus.js";

export default {
    name: "browse",
    components: { Navi, Footer, Box, Pie, Tab, Bar,CellTab },
    data: function () {
        return {
            error_page: true,
            loading: true,
            task_id: '',
            error_msg: "The url doesn't contain job ID! Please find your result link.",
            progress_num: 3,
            status_code: 1,
            upload_time: '',
            submit_time: '',
            run_time: '',
            finish_time: '',
            task_label: '',
            pop: '',
            ref_genome:'',
            multi_test: '',
            fwer: '',
            extend_size: '',
            remove_hla: 'No',
            email:'',
            rna_db: [],
            chr:'',
            bp:'',
            p:'',
            max_gene:'500',
            // rna_db: [
            //     { 'id': 'gtex', 'label': 'Human tissues' },
            //     { 'id': 'sc_hs', 'label': 'Human single cell types' }
            // ],
            active_RNAdb: 'gtex',
            cell_types_des:'',
            loading1: false,

            activeCollapse1: ['1', '2', '2-1', '3'],
            // activeCollapse2:['1','2','3'],
            activeCollapse2: ['1'],

            timer: '',
            status_msg: '',
            gwas_col_type:'danger',
            gene_table_data: {
                loading: false,
                sortConfig: { remote: true, defaultSort: { field: "CondiECSP", order: "asc" } },
                tableColumn: [
                    { field: 'Gene', title: 'Gene symbol', width: '18%', msg: { message: 'Gene symbol in HGNC' }, sort: true },
                    { field: 'Chromosome', title: 'Chromosome', width: '17%', msg: { message: 'Chromosome loci' }, sort: true },
                    { field:  '#Var', title: 'Number of SNPs', width: '15%', msg: { message: 'Number of SNPs included in gene for gene based association test' }, sort: true },
                    // { field: 'Group', title: 'Group', width: '10%', msg: { message: 'LD group ID of genes in conditional gene based analysis step' }, sort: true },
                    { field: 'ECSP', title: 'ECS P-value', width: '15%', msg: { message: 'Gene based association P-value calculated by ECS (effective chi-square), see details in [Help-Framework]' }, sort: true },
                    { field: 'CondiECSP', title: 'Conditional P-value', width: '20%', msg: { message: 'Conditional gene based association P-value, see details in [Help-Framework]' }, sort: true },
                    {
                        field: 'GeneScore', title: 'Gene score', width: '15%', msg: {
                            message: 'Gene score for determining the order that genes enter the conditional analysis step \
                    , see details in [Help-Framework]' }, sort: true
                    },
                ],
                tableData: [],
            },
            cell_box_data: {
                loading: true,
                width: "550px",
                height: "400px",
                plot_data: {
                    data: [],
                    val_col: '',
                    cate_col: '',
                    name_col:'',
                    detail_cols: [],
                    title: '-log10(P) of associated tissue/cell type',
                    mark_name:'Bonferroni\ncorrection',
                    mark_val:0,
                },
                empty:false
            },
            cell_bar_data: {
                loading: true,
                width: "1150px",
                height: "500px",
                empty:false
            },
            cell_pie_data: {
                loading: true,
                width: "600px",
                height: "400px",
                plot_data: {
                    data: [],
                    title: 'Category of significant tissue/cell type',
                },
                empty:false
            },
            cell_table_data: {
                loading: false,
                sortConfig: { remote: true, defaultSort: { field: "p", order: "asc" } },
                tableColumn: [
                    { field: 'cell_type_id', title: 'Tissue/cell type ID', width: '25%', msg: { message: 'Tissue/single cell type ID' }, sort: true },
                    { field: 'cell_type', title: 'Tissue/cell type name', width: '18%', msg: { message: 'Tissue/single cell type name' }, sort: true },
                    { field: 'category_cell_type', title: 'Category', width: '17%', msg: { message: 'Category of tissues/cell types' }, sort: true },
                    { field: 'source', title: 'Source organ', width: '15%', msg: { message: 'Organ where the tissue/single cell type sampling' }, sort: true },
                    { field: 'p', title: 'P-value', width: '9%', msg: { message: 'P-value of association between tissue/cell type and phenotype' }, sort: true },
                    { field: 'adj_p', title: 'Adjusted P-value', width: '16%', msg: { message: 'Adjusted P-values by permutation' }, sort: true },
                ],
                tableData: [],
            },
            phenotype_box_data: {
                loading: true,
                width: "550px",
                height: "400px",
                plot_data: {
                    data: [],
                    val_col: '',
                    cate_col: '',
                    detail_cols: [],
                    title: 'Jaccard index of phenotypes in PCGA',
                },
                empty:false
            },
            phenotype_pie_data: {
                loading: true,
                width: "600px",
                height: "400px",
                plot_data: {
                    data: [],
                    title: 'Categories of similar phenotypes',
                },
                empty:false
            },
            phenotype_table_data: {
                loading: false,
                sortConfig: { remote: true, defaultSort: { field: "sim", order: "desc" } },
                tableColumn: [
                    { field: 'id', title: 'GWAS ID', width: '18%', msg: { message: 'GWAS ID' }, sort: true },
                    { field: 'trait', title: 'Phenotype name', width: '30%', msg: { message: 'Phenotype description of GWAS' }, sort: true },
                    { field: 'mesh_term', title: 'MeSH term', width: '20%', msg: { message: 'MeSH term of phenotype' }, sort: true },
                    { field: 'category', title: 'Category', width: '17%', msg: { message: 'Category of phenotype' }, sort: true },
                    { field: 'sim', title: 'Jaccard index', width: '15%', msg: { message: 'Jaccard index of associated genes' }, sort: true },
                ],
                tableData: [],
            },
            now_time:''
        };
    },
    created:function(){
        this.getTaskID();
    },
    mounted: function () {
        var _this = this;
        _this.loadData();
        this.timer = setInterval(function () {
            if (_this.progress_num == 5) {
                clearInterval(_this.timer);
            } else {
                _this.loadData();
            }
        }, 8000);

    },
    destroyed() {
        clearInterval(this.timer)
    },

    methods: {
        getTaskID() {
            if ('task_id' in this.$route.query) {
                this.task_id = this.$route.query.task_id;
            } else {
                _this.error_page = true;
            }
        },
        loadData() {
            this.now_time=getTime(Date.parse(new Date())/1000)
            var _this = this
            var rna_db_ref = { 'gtex': 'Human tissues', 'sc_hs': 'Human single cell types', 'sc_mm': 'Mouse single cell types' }
            var method_name = {
                "bonf": "Standard Bonferroni correction",
                "benfdr": "Benjamini-Hochberg FDR", "fixed": "Fixed p-value"
            }
            axios
                .get(api_dir + "/api.php?action=check_task", {
                    params: { 'task_id': _this.task_id },
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    if (res.error_code == 0) {
                        // _this.$notify({
                        //     title: "Success",
                        //     message: "Checked successfully",
                        //     type: "success",
                        //     duration: 2000,
                        // });
                        _this.status_code = res.data.status;
                        if (_this.status_code==4){
                            _this.gwas_col_type='success'
                        }
                        _this.status_msg = res.data.status_msg;
                        if ('email' in res.data){
                            _this.email=res.data['email'];
                        }
                        for (var t of ['upload_time', 'submit_time', 'run_time', 'finish_time']) {
                            _this.$data[t] = getTime(res.data[t]);
                        }
                        for (var x of ['task_label', 'pop', 'fwer', 'extend_size','ref_genome','chr','bp','p','max_gene']) {
                            // _this.$data[x]='';
                            if(res.data.parameter[x]!=null){
                                _this.$data[x] = res.data.parameter[x];
                            }
                        }
                        _this.multi_test = method_name[res.data.parameter['multi_test']];
                        if (res.data.parameter['mhc'] == "0") {
                            _this.remove_hla = "No";
                        } else {
                            _this.remove_hla = "Yes";
                        }
                        var dbs = res.data.parameter['cell_db'].split(',');
                        var switch_db = [];
                        for (var db of dbs) {
                            switch_db.push({ 'id': db, 'label': rna_db_ref[db] })
                        }
                        //descripe cell types
                        if(res.data.parameter.sc_range!='manual'){
                            var fwer_tmp=0.05
                            var top_tmp=1
                            if(res.data.parameter.sc_range_fwer){
                                fwer_tmp=res.data.parameter.sc_range_fwer
                            }
                            if(res.data.parameter.sc_range_top_num){
                                top_tmp=res.data.parameter.sc_range_top_num
                            }
                            _this.cell_types_des='Automatically select according to associated tissues with Bonferroni corrected P < '+fwer_tmp+' OR Top '+top_tmp;
                        }else{
                            if(res.data.parameter.sc_organs){
                                _this.cell_types_des='Manually select: '+res.data.parameter.sc_organs.replaceAll(/sc_hs:/g,'Human cell types from: ').replaceAll(/sc_mm:/g,'Mouse cell types from: ')
                                .replaceAll(/[,]/g,', ').replaceAll(/[;]/g,'; ')
                            }
                        }
                        _this.rna_db = switch_db;
                        _this.progress_num = _this.getProgress(res.data.status);
                        if (_this.progress_num == 5) {
                            _this.loadGeneFullData();
                            _this.loadCellFullData();
                            _this.loadPhenotypeFullData();
                        }
                    } else {
                        _this.error_page = true;
                        _this.error_msg = "No such task_id: " + _this.task_id + ". Please check!";
                        _this.$notify({
                            title: "Illegal operation",
                            message: 'No such task_id',
                            type: "error",
                            duration: 5000,
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },
        getProgress(status) {
            let map_s = { 0: 1, 1: 3, 2: 4, 3: 5, 4: 5 };
            return map_s[status];
        },

        loadGeneFullData() {
            var _this = this
            var para = {
                'action': 'check_phenotype_assoc_gene_full',
                'task_id': this.task_id,
                'type': this.active_RNAdb
            }
            _this.gene_table_data.loading = true;
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    let table_data = echartTable2vxeTable(res);
                    for(var s of table_data){
                        s['Gene']='<a target="_blank" class="table_a" style="" href="#/results/gene?id='+s['Gene']+'">'+s['Gene']+'</a>'
                    }
                    _this.gene_table_data.tableData = table_data;
                    _this.gene_table_data.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },

        loadCellFullData() {
            var _this = this
            var para = {
                'action': 'check_phenotype_assoc_cell_full',
                'task_id': this.task_id,
                'type': this.active_RNAdb
            }
            _this.cell_box_data.loading = true;
            _this.cell_pie_data.loading = true;
            _this.cell_table_data.loading = true;
            _this.cell_bar_data.loading = true;
            _this.cell_box_data.empty = false;
            _this.cell_pie_data.empty = false;
            _this.cell_bar_data.empty = false;
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    //do table
                    let table_data = echartTable2vxeTable(res);
                    for(var s of table_data){
                        s['cell_type_id']='<a target="_blank" class="table_a" href="#/results/cell?id='+s['cell_type_id']+'">'+s['cell_type_id']+'</a>'
                        if(s['p']<0.01/s['count']){
                            s['rate']=3
                        }else if(s['p']<0.05/s['count']){
                            s['rate']=2
                        }else if(s['p']<0.05){
                            s['rate']=1
                        }
                    }
                    _this.cell_table_data.tableData = table_data;
                    _this.cell_table_data.loading = false;
                    //判断是否为空
                    if(res.length==0){
                        _this.cell_box_data.loading = false;
                        _this.cell_pie_data.loading = false;
                        _this.cell_bar_data.loading = false;
                        _this.cell_box_data.empty = true;
                        _this.cell_pie_data.empty = true;
                        _this.cell_bar_data.empty = true;
                    }else{
                    //do fig
                    const p_para={
                        'p':{'name':'-log10(P-value)','index':0,'pcut':(0.05/(res.length-1))},
                        'adj_p':{'name':'-log10(Adj.P-value)','index':1,'pcut':0.05}
                    }
                    const p_type='p'
                    for (var i = 1; i < res.length; i++) {
                        res[i][p_para[p_type]['index']] = -Math.log10(res[i][p_para[p_type]['index']]);
                    }
                    var switch_name = {
                        'adj_p': p_para['adj_p']['name'],
                        'p':p_para['p']['name'],
                        'cell_type_id': 'Tissue/Cell type ID',
                        "cell_type": "Tissue/Cell type",
                        "category_cell_type": "Category",
                    }
                    for (var i = 0; i < res[0].length; i++) {
                        res[0][i] = switch_name[res[0][i]];
                    }
                    _this.cell_box_data.plot_data.data = res;
                    _this.cell_box_data.plot_data.val_col = p_para[p_type]['name'];
                    _this.cell_box_data.plot_data.cate_col = 'Category';
                    _this.cell_box_data.plot_data.name_col = 'Tissue/Cell type ID';
                    _this.cell_box_data.plot_data.detail_cols = ['Tissue/Cell type ID', 'Tissue/Cell type', 'Category', p_para[p_type]['name']];
                    _this.cell_box_data.plot_data.mark_val=-Math.log10(p_para[p_type]['pcut']);
                    _this.cell_box_data.loading = false;
                    _this.cell_bar_data.plot_data=_this.cell_box_data.plot_data;
                    _this.cell_bar_data.loading = false;
                    var category_idx = res[0].indexOf('Category');
                    var p_idx = p_para[p_type]['index'];
                    var k = 0;
                    // var pcut = -Math.log10(0.05 / (res.length - 1));
                    var pcut = -Math.log10( p_para[p_type]['pcut']);
                    var map_val = {};
                    for (var i = 1; i < res.length; i++) {
                        if (res[i][p_idx] >= pcut) {
                            if (!(res[i][category_idx] in map_val)) {
                                map_val[res[i][category_idx]] = 0;
                            }
                            map_val[res[i][category_idx]] += 1;
                        }
                    }
                    var pdata = []
                    for (var x in map_val) {
                        pdata.push({ name: x, value: map_val[x] });
                    }
                    // console.log(pdata)
                    _this.cell_pie_data.plot_data.data = pdata;
                    _this.cell_pie_data.loading = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },

        loadPhenotypeFullData() {
            var _this = this
            var para = {
                'action': 'check_phenotype_similarity_full',
                'task_id': this.task_id,
                'type': this.active_RNAdb
            }
            _this.phenotype_box_data.loading = true;
            _this.phenotype_pie_data.loading = true;
            _this.phenotype_table_data.loading = true;
            _this.phenotype_box_data.empty = false;
            _this.phenotype_pie_data.empty = false;
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    //do table
                    var table_data = echartTable2vxeTable(res);
                    for(var s of table_data){
                        s['id']='<a target="_blank" class="table_a" href="#/results/phenotype?id='+s['id']+'">'+s['id']+'</a>'
                    }
                    _this.phenotype_table_data.tableData = table_data;
                    _this.phenotype_table_data.loading = false;
                    //do fig
                    if(res.length==0){
                        _this.phenotype_box_data.loading = false;
                        _this.phenotype_pie_data.loading = false;
                        _this.phenotype_box_data.empty = true;
                        _this.phenotype_pie_data.empty = true;
                    }else{
                    var switch_name = {
                        'sim': 'Jaccard index',
                        'id': 'GWAS ID',
                        "trait": "Phenotype name",
                        "mesh_term": "MeSH term",
                        "category": "Category",
                    }
                    for (var i = 0; i < res[0].length; i++) {
                        res[0][i] = switch_name[res[0][i]];
                    }
                    // console.log(res)
                    _this.phenotype_box_data.plot_data.data = res;
                    _this.phenotype_box_data.plot_data.val_col = 'Jaccard index';
                    _this.phenotype_box_data.plot_data.cate_col = 'Category';
                    _this.phenotype_box_data.plot_data.detail_cols = ['GWAS ID', 'Phenotype name', 'Category', 'Jaccard index', 'MeSH term'];
                    _this.phenotype_box_data.loading = false;
                    var category_idx = res[0].indexOf('Category');
                    var p_idx = res[0].indexOf('Jaccard index');
                    var k = 0;
                    var map_val = {};
                    for (var i = 1; i < res.length; i++) {
                        if (!(res[i][category_idx] in map_val)) {
                            map_val[res[i][category_idx]] = 0;
                        }
                        map_val[res[i][category_idx]] += 1;
                    }
                    var pdata = []
                    for (var x in map_val) {
                        pdata.push({ name: x, value: map_val[x] });
                    }
                    // console.log(pdata)
                    _this.phenotype_pie_data.plot_data.data = pdata;
                    _this.phenotype_pie_data.loading = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },

        switchRNAdb(tab) {
            this.active_RNAdb = tab.name;
            this.loadGeneFullData();
            this.loadCellFullData();
            this.loadPhenotypeFullData();
            // console.log(this.active_RNAdb);
        },
        download(type) {
            var type_act = { 'gene': 'download_task_phenotype_assoc_gene', 'cell': 'download_task_phenotype_assoc_cell', 'phenotype': 'download_task_phenotype_similarity' };
            var act = type_act[type];
            var _this = this
            var para = {
                'response': 'file',
                'action': act,
                'task_id': this.task_id,
                'type': this.active_RNAdb
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                }, {
                    responseType: 'blob'
                })
                .then(function (res) {
                    const content = res.data
                    const blob = new Blob([content])//构造一个blob对象来处理数据
                    var fileName = 'associated_' + type + '.csv'
                    if (type == 'phenotype') {
                        fileName = 'similar_phenotypes.csv';
                    }
                    //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
                    //IE10以上支持blob但是依然不支持download
                    if ('download' in document.createElement('a')) { //支持a标签download的浏览器
                        const link = document.createElement('a')//创建a标签
                        link.download = fileName//a标签添加属性
                        link.style.display = 'none'
                        link.href = URL.createObjectURL(blob)
                        document.body.appendChild(link)
                        link.click()//执行下载
                        URL.revokeObjectURL(link.href) //释放url
                        document.body.removeChild(link)//释放标签
                    } else { //其他浏览器
                        navigator.msSaveBlob(blob, fileName)
                    }
                    this.$notify({
                        title: "Download successfully",
                        message: '',
                        type: "success",
                        duration: 2000,
                    });
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },
        add_email() {
        this.$prompt('Input your email address and you will be notified when the job is complete.', 'Notify via email', {
          confirmButtonText: 'Submit',
          cancelButtonText: 'Cancel',
          inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: 'Incorrect email address'
        }).then(({ value }) => {
            value=value.trim();
            var _this = this
            var para = {
                'action': 'update_email',
                'task_id': this.task_id,
                'email': value
            }
            axios
                .get(api_dir + "/api.php", {
                    params:para
                }).then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    if(res['error_code']==0){
                        _this.$message({
                            type: 'success',
                            message: 'Successfully sumbmit your email: ' + value
                        });
                        _this.email=value;
                    }else{
                        _this.$message({
                            type: 'error',
                            message: 'Failed'
                        });
                    }
                }).catch(function(){
                    _this.$message({
                    type: 'error',
                    message: 'Failed'
                    });   
                });

        }).catch(() => {
        //   this.$message({
        //     type: 'info',
        //     message: 'Cancel'
        //   });       
        });
      }

    },
};
</script>



<style scoped>
.tip_box {
    padding: 15px 20px;
    background-color: #fdf6ec;
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 12px;
}

/* .task_progress {
    margin-top: 20px;
} */


.task_progress >>> .el-step__title {
    font-size: 14px;
    line-height: 28px;
}
.task_progress >>> .el-step__description {
    font-size: 12px;
}
.current_status_box{
    margin-bottom: 20px;
    padding-left: 15px;
    font-size: 15px;
}

</style>

<style>
.el-collapse-item__header {
    font-size: 16px;
    font-weight: bold;
}
.el-alert__title {
    font-size: 15px;
}
.el-alert .el-alert__description {
    font-size: 14px;
}
.el-step__icon {
    height: 22px;
    width: 22px;
}

</style>


// WEBPACK FOOTER //
// src/views/results/phenotype_task.vue